export default __webpack_public_path__ + "static/media/P20-sm-close.3f2ebabf.svg";